import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.TogglePanels,
  title: 'Toggle Panels',
  category: ComponentCategory.Layout,
};
